import inputStyles from "../../../styles/UI/inputFields.module.css";

type Direction = "ROW" | "COLUMN";

const InputTextField = ({
  label,
  value,
  placeholder,
  direction,
  onInputChange,
  disabled,
  classes,
}: {
  label: string;
  value: string
  placeholder: string,
  direction?: Direction;
  onInputChange: (value: string) => void;
  disabled?: boolean
  classes?: string
}) => {
  return (
    <label
      htmlFor="inputText"
      className={`flex gap-[var(--spacing-xs)] ${direction === "COLUMN" ? "flex-col" : "flex items-center"} ${classes ? classes : null}`}
    >
      <span className={`pl-2 ${inputStyles.label}`}>{label}</span>
      <input
        className={inputStyles.inputFields}
        type="text"
        id="inputText"
        value={value}
        disabled={disabled}
        placeholder={placeholder}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          onInputChange(event.target.value);
        }}
      />
    </label>
  );
};

export default InputTextField;
